import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Concierge } from "@/components/Concierge";
import Home from "@/pages/Home";
import Tours from "@/pages/Tours";
import Blog from "@/pages/Blog";
import Founder from "@/pages/Founder";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    const titles = { "/": "Heritage. Culture. Stories.", "/experiences": "Experiences", "/about": "About", "/blog": "Blog", "/contact": "Let’s Plan Your Visit", "/privacy": "Privacy", "/terms": "Terms", "/legal": "Policies" };
    document.title = `Unzip Delhi | ${titles[pathname] || "Heritage. Culture. Stories."}`;
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    const frame = window.requestAnimationFrame(() => target?.scrollIntoView({ behavior: "auto", block: "start" }));
    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash, key]);
  return null;
};

const Shell = () => {
  return (
    <>
      <ScrollToTop />
      <div className="grain-overlay" />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experiences" element={<Tours />} />
        <Route path="/tours" element={<Navigate to="/experiences" replace />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about" element={<Founder />} />
        <Route path="/founder" element={<Navigate to="/about#anas-khan" replace />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Footer />
      <WhatsAppFloat />
      <Concierge />
      <Toaster position="top-center" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
